import { PrizeLogicMenu } from "../components/organisms/PrizeLogicMenu";

export const PrizeLogicHubPage = () => <PrizeLogicMenu />;
